import React, { useEffect } from 'react';

const CustomHtml = () => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://assets.seedrs.com/campaign-scripts/govox-v1.js';
    script.async = true;

    document.getElementById('campaign-script').appendChild(script);

    return () => {
      document.getElementById('campaign-script').removeChild(script);
    };
  }, []);

  return (
    <div id="campaign-script" />
  );
};

export default CustomHtml;
